import { useMemo } from "react";

export default function Menu({ userType }) {
  const showSuper = userType === 1;
  const showMaster = userType === 1 || userType === 2;
  const showUser = userType === 1 || userType === 2 || userType === 3 || userType === 5;
  const showOnly =  userType === 2 || userType === 3;

  // 🔹 UseMemo to build menu dynamically — easier to maintain
  const menuItems = useMemo(
    () =>
      [
        { key: "exchange", label: "EXCH", className: "menuExchange" },
        showSuper && {
          key: "super",
          label: "SUPER",
          className: "menuExchange",
        },
        showMaster && {
          key: "master",
          label: "MASTER",
          className: "menuExchange",
        },
        showUser && { key: "user", label: "USER", className: "menuExchange" },
        { key: "symbol", label: "SYMBOL", className: "menuSymbol" },
        { key: "expiry", label: "EXPIRY", className: "menuExpiry" },
        { key: "buySell", label: "BUY/SELL", className: "menuBuyPrice" },
        { key: "qty", label: "QTY", className: "menuBuyQty" },
        { key: "rate", label: "RATE", className: "menuSellPrice" },
        { key: "liveRate", label: "LIVE RATE", className: "menuSellPrice" },
        { key: "pl", label: "P/L", className: "menuClose" },
        showUser && {
          key: "selfPl",
          label: "SELF P/L",
          className: "menuClose",
        },
        { key: "lttLut", label: "LTT/LUT", className: "menuLtt" },
        showOnly && { key: "date", label: "DATE", className: "menuLtt" },
        showOnly &&
          {
            key: "dateUpdate",
            label: "UPDATE-DATE",
            className: "menuLtt",
          },
        showUser && {
          key: "trade",
          label: "TRADE",
          className: "menuBuyQty",
        },
      ].filter(Boolean), // remove falsy entries
    [showSuper, showMaster, showUser]
  );

  return (
    <div className="menuContainer primary white">
      <div className="menuIcon" />
      {menuItems.map((item) => (
        <div key={item.key} className={item.className}>
          {item.label}
        </div>
      ))}
    </div>
  );
}
